import axios from 'axios';
const client = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL, // Replace with your API base URL
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}` // Replace with your token logic        
    }
  })
export default client;
